import tw from "twin.macro"

export const TwCard = tw.div`lg:bg-white px-2 lg:p-8 rounded-lg lg:shadow-lg w-full max-w-md`
export const TwContent = tw.p`text-center text-light-secondary lg:text-gray-600 mb-6`
export const TwTheLines = tw.div`border-t border-gray-300 flex-grow`